<ras-page [show_heading]="true" *ngIf="location" [headingHtml]="'<b>' + location.name + '</b>'" [mapUrl]="location.map_url" [description]="location.description">

	<main>
		<div class="breadcrumbs">
			<a [routerLink]="['/']">Home</a>
			&gt;
			<a [routerLink]="['/storage-facility', location.key]">{{location.name}}</a>
			&gt;
			Storage units
		</div>

		<h1>Thank you for your enquiry</h1>

		<p>We apologise, but we are unable to process online rentals for non South Afrcan I.D. document holders at this time. One of our consultants will contact you telephonically to assist with your storage requirements.</p>

		<p>If you require any further assistance please do not hesisitate to call us on <b>0861 73 68 27</b> during office hours.</p>
	</main>

	<ras-testimonial></ras-testimonial>

</ras-page>
